import { useMemo } from "react";
import { useParams } from "react-router";
import { TopBar } from "../components/TopBar";
import { useManifestStore } from "../state/manifestStore";
import { useSettings } from "../state/settingsStore";

export function Settings() {
  const { tenant } = useParams();
  const manifest = useManifestStore((s) => s.manifest);
  const syntheticOnly = useSettings((s) => s.syntheticOnly);
  const setSyntheticOnly = useSettings((s) => s.setSyntheticOnly);

  const counts = useMemo(() => {
    if (!manifest || !tenant) return { total: 0, synthetic: 0 };
    const tenantSessions = manifest.sessions.filter((s) => s.tenant === tenant);
    return {
      total: tenantSessions.length,
      synthetic: tenantSessions.filter((s) => s.synthetic).length,
    };
  }, [manifest, tenant]);

  if (!tenant) return null;

  return (
    <>
      <TopBar tenant={tenant} title="Settings" />
      <div className="app-content">
        <section className="card">
          <h2>Demo dataset</h2>
          <p className="meta-label" style={{ marginBottom: 12 }}>
            Choose which sessions appear in the dashboard for this tenant.
          </p>

          <label className="toggle-row">
            <input
              type="checkbox"
              checked={syntheticOnly}
              onChange={(e) => setSyntheticOnly(e.target.checked)}
            />
            <div className="toggle-label">
              <strong>Synthetic sessions only</strong>
              <p className="meta-label">
                Hide WildChat-derived sessions. Show only the {counts.synthetic} curated
                spec-generated sessions for {tenant} (out of {counts.total} total).
              </p>
            </div>
          </label>
        </section>

        <section className="card">
          <h2>About the data</h2>
          <dl className="settings-dl">
            <div>
              <dt>WildChat-derived</dt>
              <dd>
                Conversations filtered from the public WildChat-4.8M dataset using a broad
                professional-vocabulary keyword pass, then assigned to a tenant via
                sentence-embedding similarity. Authentic but variable quality.
              </dd>
            </div>
            <div>
              <dt>Synthetic</dt>
              <dd>
                Conversations generated from labelled scenario specs (see
                <code>replayer/synthetic_specs.yaml</code>) using Claude Haiku. Every session has a
                known pattern (Sycophancy, Confabulation, etc.) and a labelled evidence turn.
                Highest fidelity for demo purposes.
              </dd>
            </div>
          </dl>
        </section>
      </div>
    </>
  );
}
